"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _mixins = require("../../styles/mixins");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _Ai = _interopRequireDefault(require("@honeybook/icons/dist/icons/Ai12"));
var _Ai2 = _interopRequireDefault(require("@honeybook/icons/dist/icons/Ai16"));
var _Ai3 = _interopRequireDefault(require("@honeybook/icons/dist/icons/Ai20"));
var avatarAIConfig = {
  xs: {
    wrapperSize: 16,
    icon: _Ai["default"]
  },
  sm: {
    wrapperSize: 24,
    icon: _Ai2["default"]
  },
  md: {
    wrapperSize: 32,
    icon: _Ai3["default"]
  }
};
var HBAvatarAI = function HBAvatarAI(_ref) {
  var _avatarAIConfig$size$, _avatarAIConfig$size;
  var size = _ref.size,
    className = _ref.className;
  var icon = (_avatarAIConfig$size$ = (_avatarAIConfig$size = avatarAIConfig[size]).icon) === null || _avatarAIConfig$size$ === void 0 ? void 0 : _avatarAIConfig$size$.call(_avatarAIConfig$size, {
    className: className,
    useDefaultFill: true
  });
  return /*#__PURE__*/_react["default"].createElement(Container, {
    $size: avatarAIConfig[size].wrapperSize
  }, icon);
};
var _default = exports["default"] = HBAvatarAI;
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBAvatarAI__Container",
  componentId: "sc-1jbaain-0"
})(["", " height:", "px;width:", "px;min-height:", "px;min-width:", "px;border-radius:", "px;background-color:", ";border:1px solid ", ";i{display:flex;}"], _mixins.flexCenterAll, function (_ref2) {
  var $size = _ref2.$size;
  return $size;
}, function (_ref3) {
  var $size = _ref3.$size;
  return $size;
}, function (_ref4) {
  var $size = _ref4.$size;
  return $size;
}, function (_ref5) {
  var $size = _ref5.$size;
  return $size;
}, function (_ref6) {
  var $size = _ref6.$size;
  return $size / 4;
}, _colors["default"].white, _colors["default"].neutral400);
//# sourceMappingURL=HBAvatarAI.js.map